import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import useAuthStore from '../store/authStore';
import { diasParaVencer } from '../utils/verificarValidade';

const cor = '#B51013';

export default function AlertaDiario() {
  const usuario = useAuthStore((s) => s.usuario);
  const navigate = useNavigate();
  const [alertas, setAlertas] = useState([]);
  const [visivel, setVisivel] = useState(false);

  useEffect(() => {
    if (!usuario) return;
    const hoje = new Date().toDateString();
    const chave = `alerta_diario_${usuario.uid}_${hoje}`;
    if (localStorage.getItem(chave)) return; // já viu hoje

    getDoc(doc(db, 'progresso', usuario.uid)).then(snap => {
      if (!snap.exists()) return;
      const trein = snap.data().treinamentos || {};
      const lista = [];
      Object.entries(trein).forEach(([nome, info]) => {
        if (info.status === 'vencido') lista.push({ nome, tipo: 'vencido', label: 'VENCIDO', urgente: true });
        else if (info.status === 'concluido' && info.venceEm) {
          const dias = diasParaVencer(info.venceEm);
          if (dias !== null && dias <= 7 && dias >= 0)
            lista.push({ nome, tipo: 'urgente', label: `Vence em ${dias} dia(s)`, urgente: true });
        }
      });
      if (lista.length > 0) {
        setAlertas(lista);
        setVisivel(true);
        localStorage.setItem(chave, '1');
      }
    }).catch(() => {});
  }, [usuario]);

  const fechar = () => setVisivel(false);

  if (!visivel || alertas.length === 0) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9995, padding: '16px',
    }}>
      <div style={{
        background: '#fff', borderRadius: '14px', padding: '28px',
        maxWidth: '420px', width: '100%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        animation: 'slideUp 0.3s ease',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <div style={{ fontSize: '36px', marginBottom: '8px' }}>⚠️</div>
          <div style={{ fontSize: '16px', fontWeight: '800', color: '#1a1a1a', marginBottom: '6px' }}>
            Atenção — treinamentos urgentes
          </div>
          <div style={{ fontSize: '13px', color: '#888' }}>
            Você tem {alertas.length} treinamento(s) que precisa(m) de ação imediata.
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '20px' }}>
          {alertas.map((a, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 12px', background: '#FCEBEB', borderRadius: '8px', borderLeft: `3px solid ${cor}` }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '12px', fontWeight: '600', color: '#1a1a1a' }}>{a.nome}</div>
                <div style={{ fontSize: '11px', color: cor, fontWeight: '600', marginTop: '2px' }}>{a.label}</div>
              </div>
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', gap: '10px' }}>
          <button onClick={fechar} style={{ flex: 1, padding: '10px', background: 'none', border: '1px solid #e0e0e0', borderRadius: '8px', fontSize: '13px', color: '#666', cursor: 'pointer' }}>
            Lembrar depois
          </button>
          <button onClick={() => { navigate('/meus-treinamentos'); fechar(); }} style={{ flex: 1, padding: '10px', background: cor, color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' }}>
            Ver agora →
          </button>
        </div>
      </div>
      <style>{`@keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }`}</style>
    </div>
  );
}
